import React from "react";
import { Chip } from "@mui/material";
import Colors from "../../../assets/Variables/ColorsVariables.js";

const StatusChip = ({ value }) => {
  let bgColor = Colors.Error_50;
  let textColor = Colors.Error_900;

  if (value === "Yes" || value === "Found" || value === "SUCCESSFUL" || value === "CONNECTION") {
    bgColor = Colors.Success_50;
    textColor = Colors.Success_900;
  } else if (value === "No" || value === "Not Found" || value === "ERROR") {
    bgColor = Colors.Error_50;
    textColor = Colors.Error_900;
  }

  if (value === "InEquity") {
    bgColor = Colors.Success_200;
    textColor = Colors.Success_900;
  } else if (value === "InBalance" || value === "INFORMATION" || value === "COPIES") {
    bgColor = Colors.Info_300;
    textColor = Colors.Info_900;
  } else if (value === "NoDrawdown" || value === "REQUESTS") {
    bgColor = Colors.Secondary_100;
    textColor = Colors.Gray_700;
  }

  if (value === "Waiting" || value === "WARNING" || value === "EVENTS") {
    bgColor = Colors.Warning_100;
    textColor = Colors.Warning_900;
  } else if (value === "InProgress") {
    bgColor = Colors.Info_200;
    textColor = Colors.Info_900;
  } else if (value === "Resolved") {
    bgColor = Colors.Success_300;
    textColor = Colors.Success_900;
  } else if (value === "Rejected") {
    bgColor = Colors.Error_700;
    textColor = Colors.Info_50;
  }

  return (
    <Chip
      label={value}
      sx={{
        height: "20px",
        minWidth: "40px",
        borderRadius: "30px",
        backgroundColor: bgColor,
        color: textColor,
        fontWeight: "400",
        fontSize: "12px",
        padding: "2px 4px 2px 4px",
        lineHeight: "1",
      }}
    />
  );
};

export default StatusChip;